import { type FC, type PropsWithChildren } from 'react';

import styles from './AdfoxParallaxBannerWrapper.css';

export const AdfoxParallaxBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-parallax-banner-wrapper']}>{children}</div>
);
